import * as React from 'react';
import whispy from '../../assets/images/whispy.png';
import './SuccessRegister.css';

export default class SuccessRegister extends React.Component<any, any> {
  public render() {
    return (
      <div id='successRegister'>
        <div>
          <img src={whispy} />
          <h4> UNE DERNIÈRE ÉTAPE !</h4>
        </div>
        <div>
          <p className='firstParagraphe'>La confirmation d’inscription a bien été envoyée !</p>
          <p>
            Rendez-vous sur votre boite mail pour finaliser l’inscription à la ressource Whisperies
            et retrouvez vos identifiants.
          </p>
          <p className='thirdParagraphe'>
            <span>Pssst !</span> <br />
            Elle s’est peut-être glissée dans vos e-mails indésirables... Vous ne la trouvez
            toujours pas ? N’hésitez pas à nous contacter, on s’en occupe !
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SuccessRegister/SuccessRegister.tsx